import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
	Box,
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControlLabel,

	InputAdornment,
	OutlinedInput,
	Typography,
	Stack,
} from "@mui/material";


import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WarningIcon from "@mui/icons-material/Warning";

export default function BidsSellerDialog(props) {
	//console.log("BidsDialogSeller", props);
	const [complete, setComplete] = useState(false);
	const [disabled, setDisabled] = useState(true);
	const handleClose = () => {
		props.onClose();
	};

	const [state, setState] = useState({
		price: 0,
		amount: 0,
		loan: 0,
		rate: 0,
		amortization: 0,
	});
	const handleChange = (event) => {
		//console.log(state);
		if (event.target.name === "amount") {
			var amt = event.target.value;
			if (amt === "") {
				return;
			}
			const amnt = Math.min(parseInt(amt, 10), state.price);


			const ln = state.price - amnt;

			setState({
				...state,
				[event.target.name]: amnt,
				loan: ln,
			});
		} else {
			setState({ ...state, [event.target.name]: event.target.value });
		}
	};

	useEffect(() => {
		//console.log(mode, params, state, parseInt(state.price, 10), state.price, parseInt(state.price, 10));
		if ((parseInt(state.price, 10) > 0)) {
			setDisabled(false);
		} else {
			setDisabled(true);
		}
	}, [state]);
	const manageSubmit = () => {

		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				...state,
				uid: props.state.params.pf.uid,
			}),
		};
		var url;

		url = "/api/newbid_vn";

		fetch(url, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};

	//console.log(params);
	Date.prototype.addDays = function (days) {
		let date = new Date(this.valueOf());
		date.setDate(date.getDate() + days);
		//console.log(date);
		return date;
	};
	let date = new Date();
	var tgdd = 2;

	const d_plus_1d = date.addDays(tgdd);
	const options = {
		weekday: "long",
		year: "numeric",
		month: "long",
		day: "numeric",
	};
	const d_plus_1d_txt = d_plus_1d.toLocaleTimeString("fr-fr", options);

	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="sm" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5">Faire une contre-proposition</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<Stack spacing={1}>
					{/* <Box display="flex" justifyContent="flex-start" alignItems="center">
						<Box>
							<WarningIcon />
						</Box>
						<Box>
							<Typography style="margin-left: 8px; ">La nouvelle proposition annule la précédente</Typography>
						</Box>
					</Box> */}
					<Box display="flex" justifyContent="flex-start" alignItems="center">
						<Box>
							<AccessTimeIcon />
						</Box>
						<Box>
							<Typography style="margin-left: 8px; height: 24px;">
								L'offre sera valable jusqu'au {d_plus_1d_txt.substring(0, d_plus_1d_txt.length - 3)}
							</Typography>
						</Box>
					</Box>

					<Box display="flex" justifyContent="flex-start" alignItems="center">
						<Box>
							<Typography>Montant de l'offre</Typography>
						</Box>
						<Box>
							<OutlinedInput
								id="price"
								name="price"
								value={state.price}
								onChange={handleChange}
								endAdornment={<InputAdornment position="end">€</InputAdornment>}
								aria-describedby="outlined-rate-helper-text"
								inputProps={{
									"aria-label": "rate",
								}}
								labelWidth={0}
								size="small"
								margin="dense"
								placeholder="Prix"
								style={{
									marginLeft: 10,
									marginRight: 10,
								}}
							/>
						</Box>
					</Box>


				</Stack>
			</DialogContent>
			<DialogActions>
				<Box display="flex" justifyContent="space-between" style="width: 100%;">
					<Box>
						<Button
							onClick={handleClose}
							variant="outlined">
							Annuler
						</Button>
					</Box>
					<Box>
						<Button
							onClick={manageSubmit}
							variant="contained">
							Proposer
						</Button>
					</Box>
				</Box>
			</DialogActions>
		</Dialog>
	);
}
